import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ChartingComponent } from './charting.component';
import { ChartingToothAreaComponent } from './charting-tooth-area/charting-tooth-area.component';
import { ChartingToothSectionsComponent } from './charting-tooth-sections/charting-tooth-sections.component';
import { ChartingToothComponent } from './charting-tooth/charting-tooth.component';

@NgModule({
  declarations: [
    ChartingComponent,
    ChartingToothAreaComponent,
    ChartingToothSectionsComponent,
    ChartingToothComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    ChartingComponent
  ]
})
export class ChartingModule { }
